/* ================================================
   MATCHA VISUAL STORY — C'est du nanan
   Native scroll + Canvas particle system
   ================================================ */

(function () {
  'use strict';

  var LEAF_IMG_SRC   = 'https://cdn.shopify.com/s/files/1/0588/5673/4929/files/tea_leaf.png?v=1778194055';
  /* モバイル（640px以下）はパーティクルを半減して描画負荷を下げる */
  var PARTICLE_COUNT = window.matchMedia('(max-width: 640px)').matches ? 1200 : 2400;
  var SAMPLE_GRID    = 180;

  /* 初期バージョンの色設定を復元 */
  var COLORS = [
    [100, 55, 22],
    [110, 60, 28],
    [118, 65, 35],
    [125, 70, 40],
    [130, 68, 45],
    [118, 55, 50],
    [105, 50, 30],
    [135, 72, 48],
  ];

  /* ═══════════════════════════════════════════
     Particle system (Float32Array for perf)
  ═══════════════════════════════════════════ */
  function ParticleSystem(canvas, W, H) {
    this.canvas = canvas;
    this.ctx    = canvas.getContext('2d');
    this.W = W;
    this.H = H;
    this.leafX  = new Float32Array(PARTICLE_COUNT);
    this.leafY  = new Float32Array(PARTICLE_COUNT);
    this.scatX  = new Float32Array(PARTICLE_COUNT);
    this.scatY  = new Float32Array(PARTICLE_COUNT);
    this.convX  = new Float32Array(PARTICLE_COUNT);
    this.convY  = new Float32Array(PARTICLE_COUNT);
    this.sizes  = new Float32Array(PARTICLE_COUNT);
    this.hue    = new Float32Array(PARTICLE_COUNT);
    this.sat    = new Float32Array(PARTICLE_COUNT);
    this.lit    = new Float32Array(PARTICLE_COUNT);
    this.phase  = new Float32Array(PARTICLE_COUNT);
  }

  ParticleSystem.prototype.build = function (leafPoints) {
    var W = this.W, H = this.H;
    var cx = W / 2, cy = H / 2;
    var leafSize = Math.min(W, H) * 0.42;

    for (var i = 0; i < PARTICLE_COUNT; i++) {
      var src = leafPoints[i % leafPoints.length];

      this.leafX[i] = cx + (src.nx - 0.5) * leafSize;
      this.leafY[i] = cy + (src.ny - 0.5) * leafSize;

      var angle = Math.random() * Math.PI * 2;
      var minD  = Math.min(W, H) * 0.25;
      var maxD  = Math.max(W, H) * 0.75;
      var dist  = minD + Math.random() * (maxD - minD);
      var biasY = -cy * 0.4 * Math.random();
      this.scatX[i] = cx + Math.cos(angle) * dist;
      this.scatY[i] = cy + Math.sin(angle) * dist * 0.55 + biasY;

      var ca = (i / PARTICLE_COUNT) * Math.PI * 10;
      var cd = 20 + (i / PARTICLE_COUNT) * 95;
      this.convX[i] = cx + Math.cos(ca) * cd;
      this.convY[i] = cy + Math.sin(ca) * cd;

      this.sizes[i] = 0.6 + Math.random() * 2.2;
      this.phase[i] = Math.random();

      var col = COLORS[Math.floor(Math.random() * COLORS.length)];
      this.hue[i] = col[0] + (src.hBias || 0) * 15;
      this.sat[i] = col[1] + Math.random() * 15 - 7;
      this.lit[i] = col[2] + Math.random() * 18 - 9;
    }
  };

  /* 初期バージョンのフェーズタイミングを復元
     0.00–0.20 : 茶葉に集合
     0.20–0.55 : 爆発・散乱
     0.55–0.80 : 粉末が漂う
     0.80–1.00 : 収束                    */
  ParticleSystem.prototype.draw = function (progress) {
    var ctx = this.ctx;
    ctx.clearRect(0, 0, this.W, this.H);

    for (var i = 0; i < PARTICLE_COUNT; i++) {
      var x, y, alpha, sz;
      var p = this.phase[i];

      if (progress < 0.20) {
        var t  = clamp01(progress / 0.20);
        var st = clamp01(t / (0.5 + p * 0.5));
        var se = easeOut(st);
        x  = lerp(this.scatX[i] * 0.18 + this.W * 0.5 * 0.82, this.leafX[i], se);
        y  = lerp(this.scatY[i] * 0.18 + this.H * 0.5 * 0.82, this.leafY[i], se);
        alpha = se * 0.85;
        sz = this.sizes[i] * (0.5 + se * 0.5);

      } else if (progress < 0.55) {
        var t2  = clamp01((progress - 0.20) / 0.35);
        var st2 = clamp01((t2 - p * 0.15) / 0.85);
        var se2 = easeInOut(st2);
        x  = lerp(this.leafX[i], this.scatX[i], se2);
        y  = lerp(this.leafY[i], this.scatY[i], se2);
        alpha = 0.85 - se2 * 0.25;
        sz = this.sizes[i] * (1 + se2 * 0.8);

      } else if (progress < 0.80) {
        var t3    = clamp01((progress - 0.55) / 0.25);
        var driftX = Math.sin(p * 6.28 + t3 * 3.14) * 22;
        var driftY = Math.cos(p * 6.28 + t3 * 2.1)  * 14 - t3 * 18;
        x  = this.scatX[i] + driftX;
        y  = this.scatY[i] + driftY;
        alpha = 0.60 - t3 * 0.15;
        sz = this.sizes[i];

      } else {
        var t4  = clamp01((progress - 0.80) / 0.20);
        var st4 = clamp01((t4 - (1 - p) * 0.2) / 0.8);
        var se4 = easeInOut(st4);
        var px4 = this.scatX[i] + Math.sin(p * 6.28) * 22;
        var py4 = this.scatY[i] + Math.cos(p * 6.28) * 14 - 18;
        x  = lerp(px4, this.convX[i], se4);
        y  = lerp(py4, this.convY[i], se4);
        alpha = 0.45 + se4 * 0.5;
        sz = this.sizes[i] * (1 - se4 * 0.35);
      }

      if (progress < 0.02) alpha *= (progress / 0.02);

      ctx.globalAlpha = clamp01(alpha);
      ctx.fillStyle = 'hsl(' + this.hue[i] + ',' + this.sat[i] + '%,' + this.lit[i] + '%)';
      ctx.beginPath();
      ctx.arc(x, y, Math.max(0.4, sz), 0, 6.2832);
      ctx.fill();
    }

    ctx.globalAlpha = 1;
  };

  /* ═══════════════════════════════════════════
     Image sampling
  ═══════════════════════════════════════════ */
  function sampleImage(img) {
    var oc  = document.createElement('canvas');
    oc.width = oc.height = SAMPLE_GRID;
    var oct = oc.getContext('2d');
    oct.drawImage(img, 0, 0, SAMPLE_GRID, SAMPLE_GRID);
    var data   = oct.getImageData(0, 0, SAMPLE_GRID, SAMPLE_GRID).data;
    var points = [];
    for (var y = 0; y < SAMPLE_GRID; y += 2) {
      for (var x = 0; x < SAMPLE_GRID; x += 2) {
        var idx = (y * SAMPLE_GRID + x) * 4;
        if (data[idx + 3] > 25) {
          points.push({
            nx: x / SAMPLE_GRID,
            ny: y / SAMPLE_GRID,
            hBias: (data[idx + 1] - data[idx]) / 255
          });
        }
      }
    }
    return points.length > 40 ? points : fallbackLeaf();
  }

  function fallbackLeaf() {
    var pts = [];
    for (var y = 0; y < SAMPLE_GRID; y += 2) {
      for (var x = 0; x < SAMPLE_GRID; x += 2) {
        var nx = x / SAMPLE_GRID, ny = y / SAMPLE_GRID;
        var dx = nx - 0.5, dy = ny - 0.5;
        var rot = 0.3;
        var rx  =  dx * Math.cos(rot) - dy * Math.sin(rot);
        var ry  =  dx * Math.sin(rot) + dy * Math.cos(rot);
        if ((rx * rx / 0.16) + (ry * ry / 0.09) < 1) {
          pts.push({ nx: nx, ny: ny, hBias: 0.3 });
        }
      }
    }
    return pts;
  }

  /* ═══════════════════════════════════════════
     Main controller
  ═══════════════════════════════════════════ */
  function MatchaStory() {
    this.wrapper  = document.getElementById('matcha-visual-story');
    this.canvas   = document.getElementById('mvs-canvas');
    this.leafImg  = document.getElementById('mvs-leaf-img');
    this.phases   = document.querySelectorAll('.mvs-phase');
    this.progFill = document.getElementById('mvs-progress-fill');
    this.progBar  = document.getElementById('mvs-progress-bar');

    if (!this.wrapper || !this.canvas) return;

    this.progress = 0;
    this.ps       = null;
    this.dpr      = Math.min(window.devicePixelRatio || 1, 2);

    this.init();
  }

  MatchaStory.prototype.init = function () {
    var self = this;
    this.visible = true;
    this.resize();
    window.addEventListener('resize', function () { self.resize(); });

    /* セクションが画面外のときは描画をスキップ → CPU/GPU 負荷を削減 */
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        self.visible = entries[0].isIntersecting;
      }, { threshold: 0 });
      io.observe(this.wrapper);
    }

    var img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload  = function () { self.onImageLoad(img); };
    img.onerror = function () { self.onImageLoad(null); };
    img.src = LEAF_IMG_SRC;
  };

  MatchaStory.prototype.onImageLoad = function (img) {
    var pts;
    try { pts = img ? sampleImage(img) : fallbackLeaf(); }
    catch (e) { pts = fallbackLeaf(); }

    this.ps = new ParticleSystem(this.canvas, this.W, this.H);
    this.ps.build(pts);
    this.setupScroll();
    this.tick();
  };

  MatchaStory.prototype.resize = function () {
    var dpr = this.dpr;
    var w   = this.canvas.offsetWidth  || window.innerWidth;
    var h   = this.canvas.offsetHeight || window.innerHeight;
    this.canvas.width  = Math.round(w * dpr);
    this.canvas.height = Math.round(h * dpr);
    this.canvas.getContext('2d').setTransform(dpr, 0, 0, dpr, 0, 0);
    this.W = w;
    this.H = h;
    if (this.ps) { this.ps.W = w; this.ps.H = h; }
  };

  MatchaStory.prototype.setupScroll = function () {
    var self = this;

    function calcProgress() {
      /* offsetTop ベース: getBoundingClientRect より Shopify で安定 */
      var scrollY    = window.pageYOffset || document.documentElement.scrollTop || 0;
      var sectionTop = self.wrapper.offsetTop;
      var sectionH   = self.wrapper.offsetHeight;
      var vh         = window.innerHeight;
      var scrolled   = scrollY - sectionTop;
      var total      = sectionH - vh;
      return total > 0 ? clamp01(scrolled / total) : 0;
    }

    window.addEventListener('scroll', function () {
      self.setProgress(calcProgress());
    }, { passive: true });

    /* 初期値をセット */
    self.setProgress(calcProgress());
  };

  MatchaStory.prototype.setProgress = function (p) {
    this.progress = p;

    if (this.progFill) this.progFill.style.width = (p * 100) + '%';
    if (this.progBar)  this.progBar.style.opacity = p > 0.85 ? String(1 - (p - 0.85) / 0.15) : '1';

    /* 茶葉画像のフェードアウト */
    if (this.leafImg) {
      var op = p < 0.15 ? 1 : p < 0.45 ? 1 - ((p - 0.15) / 0.30) : 0;
      this.leafImg.style.opacity = String(clamp01(op));
    }

    /* テキストフェーズ切り替え */
    this.phases.forEach(function (el) {
      var show =
        (el.classList.contains('mvs-phase--leaf')    && p < 0.30) ||
        (el.classList.contains('mvs-phase--powder')  && p >= 0.25 && p < 0.78) ||
        (el.classList.contains('mvs-phase--product') && p >= 0.83);
      el.classList.toggle('is-visible', show);
    });
  };

  MatchaStory.prototype.tick = function () {
    var self = this;
    if (this.ps && this.visible) this.ps.draw(this.progress);
    requestAnimationFrame(function () { self.tick(); });
  };

  /* ── Helpers ── */
  function lerp(a, b, t)   { return a + (b - a) * t; }
  function clamp01(v)       { return v < 0 ? 0 : v > 1 ? 1 : v; }
  function easeOut(t)       { return 1 - Math.pow(1 - t, 3); }
  function easeInOut(t)     { return t < 0.5 ? 4*t*t*t : 1 - Math.pow(-2*t+2,3)/2; }

  /* ── Boot ── */
  function boot() {
    if (document.getElementById('matcha-visual-story')) new MatchaStory();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

})();
